import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {ClaimAccountEmployeeTopupEventContainerModel} from '../../../../../../models';
import {Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ClaimAccountEmployeeTopupEventService extends BaseApiTemplateService<ClaimAccountEmployeeTopupEventContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'account-employee-topup-events/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'account-employee-topup-events/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'account-employee-topup-events/backoffice-ep';
    this.httpClient = http;
  }

  public createEvent(dtoObject: ClaimAccountEmployeeTopupEventContainerModel, visa: ApiVisa): Observable<ApiResponseModel<ClaimAccountEmployeeTopupEventContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'account-employee-topup-events/processors/no-recurring/backoffice-ep';
    if (visa.api_domain_url) {
        url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
          Core2Config.CLAIMS_PREFIX + 'account-employee-topup-events/processors/no-recurring/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<ClaimAccountEmployeeTopupEventContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public createRecurringEvent(dtoObject: ClaimAccountEmployeeTopupEventContainerModel, visa: ApiVisa): Observable<ApiResponseModel<ClaimAccountEmployeeTopupEventContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'account-employee-topup-events/processors/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'account-employee-topup-events/processors/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<ClaimAccountEmployeeTopupEventContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}


